var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"language-select"},_vm._l((_vm.languages),function(localeInfo){return _c('a',{staticClass:"silent",class:{
      selected: _vm.$i18n.locale === localeInfo.locale,
    },on:{"click":function($event){return _vm.setLocale(localeInfo.locale)}}},[_vm._v(_vm._s(localeInfo.title))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }